import { UserInteraction, UserInteractionFields } from '../../entities';

export type UserInteractionState = Record<UserInteractionFields, UserInteraction> & {
  isVideoSoundEnabled: boolean;
};

export const userInteractionInitialState: UserInteractionState = {
  date: { isChanged: false },
  isVideoSoundEnabled: false,
};
